/*
 *   File : index.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Index file for Manage funds container;
 *   Integrations :19-01-2022
 *   Version : v1.0
 *   Created : 14-12-2021
*/

/*import packages*/
import { useState, useEffect } from 'react';

/*import components*/
import { Accordion, AccordionDebt, FundsTab, } from '../../components/dataFormating/index';
import { Loader } from '../../components/loader';
import { FundClass, AddAssetClass, Confirmation, AddFund, CreateBasketModal, SuccessConfirmationModal } from '../../components/modal';
import { Modal } from 'bootstrap';
import SelectBox from '../../components/dropdown/selectBox';
import { PrimaryBtn, PrimaryLink, SecondaryBtn } from '../../components/cta';
import { EmptyNote, Toast } from '../../components/note';
import DeleteFund from '../../components/modal/deleteFund';
import $ from "jquery";


/*import assets*/
import AddNew from '../../assets/images/dataFormating/add-new.svg';

/*import services */
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';
import APIGet from '../../services/getApi';
import Datatable from '../../components/dataFormating/dataTable';
import { IconStyleToolTip } from '../../components/badge';

const TYPE_TAB = [
	{ title: "MFS", id: 1, value: "mfs" },
	{ title: "STP", id: 3, value: "stp" },
]

const TYPE_TAB_ACTIVE = [
	{ title: "Lumpsum", id: 1, value: "lumpsum" },
	{ title: "SIP", id: 2, value: "sip" },
	{ title: "STP", id: 3, value: "stp" },
]

const STP_LIST = [
	{
		lumpsum: "ICICI Prudential Liquid Fund Direct Plan-Growth",
		allocation: 40,
		stp: "ICICI Prudential Liquid Fund Direct Plan-Growth",
	},
	{
		lumpsum: "ICICI Prudential Liquid Fund Direct Plan-Growth",
		allocation: 40,
		stp: null,
	},
]

/* ----- basket  data ------*/
const TAB_DATA = [
	{
		name: "BASKET_ONE",
		id: 1,
		displayName: "Core baskets/Goals",
		goal: true,
	},
	{
		name: "BASKET_TWO",
		id: 2,
		displayName: "Active baskets",
		goal: true,
	},
	{
		name: null,
		id: 3,
		displayName: "Other baskets",
		goal: false,
	},
	{
		name: null,
		id: 4,
		displayName: "Asset classes",
		goal: false
	}
]


const Index = (props) => {
	const [index, setIndex] = useState(1)
	const [fundData, setFundData] = useState({});
	const [fundLoader, setFundLoader] = useState(true);
	const [basket, setBasket] = useState("BASKET_ONE")
	//eslint-disable-next-line
	const [updated, setUpdated] = useState("");
	const [isDebt, setIsDebt] = useState(false);
	const [type, setType] = useState(1);
	const [selectedYear, setSelectedYear] = useState({ label: "1 yr", value: 1 });
	const [selectedYearFd, setSelectedYearFd] = useState({ label: "6 Months", value: 7 });

	const [goal, setGoal] = useState(true);
	const [value, setValue] = useState("lumpsum");
	const [fdData, setFdData] = useState({})
	const [fdOptions, setFdOptions] = useState([]);
	const [debtOptions, setDebtOptions] = useState([]);
	const [success, setSuccess] = useState(null);
	const [error, setError] = useState(null);
	const [syncLoader, setSyncLoader] = useState(false);
	const [addFund, setAddFund] = useState(false);
	const [equityLumpsumAllocation, setEquityLumpsumAllocation] = useState(null);
	const [equitySipAllocation, setEquitySipAllocation] = useState(null);
	const [debtLumpsumAllocation, setDebtLumpsumAllocation] = useState(null);
	const [debtSipAllocation, setDebtSipAllocation] = useState(null);
	const [fdAllocation, setFdAllocation] = useState(null);
	const [editedData, setEdiedData] = useState({});
	const [assetListLoader, setAssetListLoader] = useState(false);
	const [assetList, setAssetList] = useState([]);
	const [assetData, setAssetData] = useState({});
	const [update, setUpdate] = useState(false);
	const [tooltip, setTooltip] = useState(false);
	const [stpList, setStpList] = useState([]);
	const [stpListOther, setStpListOther] = useState({});
	console.log('stpListOther =>', stpListOther, 'selectedYearFd =>', selectedYearFd);
	const [stpIndex, setStpIndex] = useState(-1);
	const [allocationLookUpId, setAllocationLookUpId] = useState(null);
	const [selectedFund, setSelectedFund] = useState(null);
	const [openFundAddModal, setOpenFundAddModal] = useState(false);
	const [otherSTPIndex, setOtherSTPIndex] = useState(null);
	const [selectedSTPIndex, setSelectedSTPIndex] = useState(null);

	const [showSuccessModal, setShowSuccessModal] = useState(false);
	const [basketCreatedStatus, setBasketCreatedStatus] = useState(false);
	const [deleteBasketLoader, setDeleteBasketLoader] = useState(false);
	// const [newlyCreatedBasketName, setNewlyCreatedBasketName] = useState(null);


	// console.log('newlyCreatedBasketName', newlyCreatedBasketName);

	console.log('equityLumpsumAllocation => ', equityLumpsumAllocation,
		"debtLumpsumAllocation =>", debtLumpsumAllocation,
		"equitySipAllocation => ", equitySipAllocation,
		"debtSipAllocation => ", debtSipAllocation
	);


	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}, []);

	useEffect(() => {
		if (index === 4) {
			_getAssetClass()
		}
		//eslint-disable-next-line
	}, [index]);

	useEffect(() => {
		if (openFundAddModal) {
			var myModal = new Modal(document.getElementById("addFund"), {});
			myModal.show();
		}
	}, [openFundAddModal])

	useEffect(() => {
		if (showSuccessModal) {
			const myModal = new Modal(document.getElementById("confirmSuccess"), {});
			myModal.show();
		}
	}, [showSuccessModal])

	useEffect(() => {
		if (index < 4) {
			_getFunds();
		}
		//eslint-disable-next-line
	}, [index]);

	useEffect(() => {
		if (addFund) {
			_openAddFundModal()
		}
	}, [addFund])
	useEffect(() => {
		_getYear();
		//eslint-disable-next-line
	}, [index]);

	useEffect(() => {
		if (error !== null) {
			setTimeout(() => {
				setError(null);
			}, 3000);
		}
	}, [error])

	useEffect(() => {
		if (success !== null) {
			setTimeout(() => {
				setSuccess(null);
			}, 3000);
		}
	}, [success])

	/* ---- get mutual funds ---*/
	const _getFunds = (loader = true) => {
		setFundLoader(loader);
		setEquityLumpsumAllocation(null);
		setFdAllocation(null);
		setDebtLumpsumAllocation(null);

		let url = devconfig.admin + '/fund/list'
		let data = JSON.stringify({
			type: basket
		});
		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {

				setFundLoader(false);
				if (basket === null) {
					setFdData(response.data.mfs);
					const temp_fd_length_arr = [];

					if (Object.keys(response.data.mfs).filter((item) => item === selectedYearFd.label).length > 0) {
						//eslint-disable-next-line
						Object.values(response.data.mfs[selectedYearFd.label]?.funds_list || {}).map((item) => {
							item.map((fund) => {
								return (
									temp_fd_length_arr.push(fund.allocation)
								);
							})
						});
						//calculation total fd allocation
						setFdAllocation(temp_fd_length_arr.reduce((a, b) => a + b, 0));
					}

					setStpListOther(response.data.stp)
				} else {
					setFundData(response.data);
					const temp_equity_lumpsum_length_arr = []
					//eslint-disable-next-line
					Object.values(response.data["lumpsum"].equity).map((item) => {
						item.map((fund) => {
							return (
								temp_equity_lumpsum_length_arr.push(fund.allocation)
							);
						})
					});
					//calculation total equity lumpsum allocation
					setEquityLumpsumAllocation(temp_equity_lumpsum_length_arr.reduce((a, b) => a + b, 0));

					const temp_equity_sip_length_arr = []
					//eslint-disable-next-line
					Object.values(response.data["sip"].equity).map((item) => {
						item.map((fund) => {
							return (
								temp_equity_sip_length_arr.push(fund.allocation)
							);
						})
					});
					//calculation total equity sip allocation
					setEquitySipAllocation(temp_equity_sip_length_arr.reduce((a, b) => a + b, 0));

					const temp_debt_lumpsum_length_arr = []
					if (Object.keys(response.data["lumpsum"].debt).filter((item) => Number(item) === selectedYear.value).length > 0) {
						//eslint-disable-next-line
						Object.values(response.data["lumpsum"].debt[selectedYear.value]).map((item) => {
							item.map((fund) => {
								return (
									temp_debt_lumpsum_length_arr.push(fund.allocation)
								);
							})
						});
						//calculation total debt allocation
						setDebtLumpsumAllocation(temp_debt_lumpsum_length_arr.reduce((a, b) => a + b, 0));

					}

					const temp_debt_sip_length_arr = []
					if (Object.keys(response.data["sip"].debt).filter((item) => Number(item) === selectedYear.value).length > 0) {
						//eslint-disable-next-line
						Object.values(response.data["sip"].debt[selectedYear.value]).map((item) => {
							item.map((fund) => {
								return (
									temp_debt_sip_length_arr.push(fund.allocation)
								);
							})
						});
						//calculation total debt allocation
						setDebtSipAllocation(temp_debt_sip_length_arr.reduce((a, b) => a + b, 0));
					}

					setStpList(response.data.stp)

				}
			}
			else {
				setFundLoader(false);
				setFundData([]);
			}
		});

	}

	const _openDeleteConfirm = (index) => {
		setSelectedFund(index);
		var myModal = new Modal(document.getElementById("delete-fund"), {});
		myModal.show();
	}

	/* ---- get year filter api ---*/
	const _getYear = (selectLatest = false) => {
		let url = devconfig.admin + '/fund/year';

		APIGet(url).then((response) => {
			if (response.status_code === 200) {
				let tempFdOptions = []
				response.data.fd.sort((a, b) => a.id - b.id).map((item) => {
					return (
						tempFdOptions.push({
							label: item.name,
							value: item.id
						})
					)
				})
				tempFdOptions.sort((a, b) => a.label.localeCompare(b.label));

				console.log('tempFdOptions', tempFdOptions, 'selectLatest =>', selectLatest); // ✅ check this log

				if (selectLatest) {
					const latestOption = tempFdOptions.reduce((max, opt) =>
						opt.value > max.value ? opt : max, tempFdOptions[0]
					);
					console.log('latestOption =>', latestOption); // ✅ check this
					setSelectedYearFd(latestOption);
				} else {
					setSelectedYearFd(tempFdOptions[0]);
				}


				setFdOptions(tempFdOptions)


				let tempDebtOptions = []
				response.data.goal.sort((a, b) => a.id - b.id).map((item) => {
					return (
						tempDebtOptions.push({
							label: item.name,
							value: item.id
						})
					)
				});
				tempDebtOptions.sort((a, b) => a.label.localeCompare(b.label));
				setDebtOptions(tempDebtOptions)
				setSelectedYear(tempDebtOptions[0])
			}
		})
	}

	/* ---- api to sync latest data with data servers  ---*/
	const _syncData = () => {
		setSyncLoader(true);

		let url = devconfig.admin + '/fund/set-basket-data';
		let data = JSON.stringify({
			"basket_type": basket,
			"is_lumpsum": type === 1 ? true : false,
			"tenure": goal ? selectedYear.value : selectedYearFd.value,
		});

		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {
				setSyncLoader(false);
				setSuccess("Data synced successfully")
			} else {
				setSyncLoader(false);
				setError(response.message)
			}
		})
	}

	/* ---- api to sync latest data with data servers  ---*/
	// const _upsertStp = () => {
	// 	setSyncLoader(true);

	// 	let requested_funds = []

	// 	// index < 3 ? stpList.map((item) => {
	// 	// 	return (
	// 	// 		requested_funds.push({
	// 	// 			"scheme_code": item.stp_scheme_code,
	// 	// 			"allocation_lookup_id": item.id,
	// 	// 		})
	// 	// 	)
	// 	// }) : stpListOther[selectedYearFd?.label].map((item) => {
	// 	// 	return (
	// 	// 		requested_funds.push({
	// 	// 			"scheme_code": item.stp_scheme_code,
	// 	// 			"allocation_lookup_id": item.id,
	// 	// 		})
	// 	// 	)
	// 	// })

	// 	if (index < 3) {
	// 		(stpList || []).forEach((item) => {
	// 			requested_funds.push({
	// 				scheme_code: item.stp_scheme_code,
	// 				allocation_lookup_id: item.id,
	// 			});
	// 		});
	// 	} else {
	// 		const stpData = stpListOther?.[selectedYearFd?.label] || [];

	// 		stpData.forEach((item) => {
	// 			requested_funds.push({
	// 				scheme_code: item.stp_scheme_code,
	// 				allocation_lookup_id: item.id,
	// 			});
	// 		});
	// 	}


	// 	let url = devconfig.admin + '/fund/upsert-stp';
	// 	let data = JSON.stringify({
	// 		"funds": requested_funds
	// 	});

	// 	APIPost(url, data).then((response) => {
	// 		if (response.status_code === 200) {
	// 			setSyncLoader(false);
	// 			setSuccess("STP List updated successfully");
	// 			_getFunds();
	// 		} else {
	// 			setSyncLoader(false);
	// 			setError(response.message)
	// 		}
	// 	})
	// }


	const _upsertStp = () => {

		const list = index < 3
			? (stpList || [])
			: (stpListOther?.[selectedYearFd?.label] || []);

		const isSameFund = list.some(
			(item) => item.scheme_code === item.stp_scheme_code
		);

		if (isSameFund) {
			setError("STP 'From' and 'To' funds cannot be the same");
			return;
		}

		const hasEmpty = list.some(item => !item.stp_scheme_code);
		if (hasEmpty) {
			setError("Please select all STP 'To' funds");
			return;
		}

		const totalAllocation = list.reduce((sum, item) => {
			return sum + Number(item.allocation || 0);
		}, 0);

		if (totalAllocation !== 100) {
			setError("Total allocation must be exactly 100%");
			return;
		}

		setSyncLoader(true);

		let requested_funds = [];

		list.forEach((item) => {
			requested_funds.push({
				scheme_code: item.stp_scheme_code,
				allocation_lookup_id: item.id,
			});
		});

		let url = devconfig.admin + '/fund/upsert-stp';
		let data = JSON.stringify({
			funds: requested_funds
		});

		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {
				setSyncLoader(false);
				setSuccess("STP List updated successfully");
				_getFunds();
			} else {
				setSyncLoader(false);
				setError(response.message)
			}
		});
	};

	/* ------ open add fund Modal -----*/
	const _openAddFundModal = () => {
		var myModal = new Modal(document.getElementById("addFundClass"), {});
		myModal.show();
	}

	/* ------ open add fund Modal -----*/
	const _openAddSTPFundModal = () => {
		setOpenFundAddModal(true);
	}

	const _openAssetModal = () => {
		var myModal = new Modal(document.getElementById("addAsset"), {});
		myModal.show();
	}

	const _openCreateBasketModal = () => {
		var myModal = new Modal(document.getElementById("create-basket"), {});
		myModal.show();
	}

	const _deleteFund = () => {
		if (index === 3) {
			const stp_list_obj = { ...stpListOther }
			const stp_list_other = [...stp_list_obj[selectedYearFd?.label]]
			stp_list_other[selectedFund]['stp_fund_name'] = null
			stp_list_other[selectedFund]['stp_scheme_code'] = null
			stp_list_obj[`${selectedYearFd?.label}`] = stp_list_other
			setStpListOther(stp_list_obj);
			setSelectedFund(null);
			return;
		}
		const stp_list = [...stpList]
		stp_list[selectedFund].stp_fund_name = null
		stp_list[selectedFund].stp_scheme_code = null
		setStpList(stp_list);
		setSelectedFund(null);
	}

	/* ------ asset class list -----*/
	const _getAssetClass = () => {
		setAssetListLoader(true);
		const url = devconfig.admin + "/asset-class/list"

		APIGet(url).then((response) => {
			if (response.status_code === 200) {
				setAssetListLoader(false);
				setAssetList(response.data);
			} else {
				setAssetListLoader(false);
				setAssetList([]);
			}
		});
	};

	const _createNewBasket = (data) => {
		const url = devconfig.admin + "/goal/add-basket";

		const payload = JSON.stringify({
			name: data.basket_name,
			min_lumpsum_amount: data.min_lumpsum_amount,
			min_sip_amount: data.min_sip_amount
		});

		APIPost(url, payload).then((response) => {
			if (response.status_code === 200) {

				setBasketCreatedStatus(true);
				// setNewlyCreatedBasketName(data.basket_name);
				const closeBtn = document.getElementById("close-create-basket");
				if (closeBtn) {
					closeBtn.dispatchEvent(new Event("click"));
				}
				// show success modal
				setTimeout(() => {
					setShowSuccessModal(true);
				}, 1000);

				_getYear(true);

			} else {
				// handle error
				setError(response.message);
				return;
			}
		});
	};

	/* Open the delete-basket confirmation for the basket currently selected in
	 * the "Other baskets" dropdown (selectedYearFd). */
	const _openDeleteBasketModal = () => {
		if (!selectedYearFd?.value) {
			setError("Select a basket to delete");
			return;
		}
		/* delete_enabled (type=null response) gates deletion server-side too;
		 * block here so the confirmation never opens for a locked basket. */
		if (!fdData?.[selectedYearFd?.label]?.delete_enabled) {
			setError("This basket cannot be deleted.");
			return;
		}
		var myModal = new Modal(document.getElementById("delete-basket-confirm"), {});
		myModal.show();
	};

	/* Delete the selected basket via /fund/delete-basket. The basket is
	 * identified by the id from the /fund/year dropdown (selectedYearFd.value),
	 * which is the basket the admin actually picked. Eligibility is enforced
	 * server-side; the backend message is surfaced on rejection. */
	const _deleteBasket = () => {
		const goalTypeId = selectedYearFd?.value;
		if (goalTypeId == null) return;
		setDeleteBasketLoader(true);

		const url = devconfig.admin + "/fund/delete-basket";
		const payload = JSON.stringify({ goal_type_id: goalTypeId });

		APIPost(url, payload).then((response) => {
			setDeleteBasketLoader(false);
			if (response.status_code === 200) {
				const closeBtn = document.getElementById("close-delete-basket");
				if (closeBtn) {
					closeBtn.dispatchEvent(new Event("click"));
				}
				setSuccess("Basket deleted successfully");
				/* refresh the basket list; _getYear() resets selectedYearFd to the
				 * first remaining option. */
				_getYear();
			} else {
				setError(response.message || "Unable to delete basket. It may have investments or pending orders.");
			}
		}).catch(() => {
			setDeleteBasketLoader(false);
			setError("Unable to delete basket. Please try again.");
		});
	};

	const stpData = stpListOther?.[selectedYearFd?.label] || [];


	function _updateStpList(code, data) {
		if (index < 3) {
			const stp_list = [...stpList]

			const fromFundCode = stp_list[selectedSTPIndex]?.scheme_code;
			if (fromFundCode === code) {
				setError("STP 'From' and 'To' funds cannot be the same");
				return;
			}
			// const index = stp_list.findIndex((item) => item.stp_fund_id === stpIndex);
			stp_list[selectedSTPIndex]['stp_fund_name'] = data.scheme_name
			stp_list[selectedSTPIndex]['stp_scheme_code'] = code
			setStpList(stp_list)
		} else {
			const stp_list_obj = { ...stpListOther }
			const stp_list_other = [...stp_list_obj[selectedYearFd?.label]];
			console.log('stp_list_other', stp_list_other);

			stp_list_other[otherSTPIndex]['stp_fund_name'] = data.scheme_name;
			stp_list_other[otherSTPIndex]['stp_scheme_code'] = code;
			// console.log('afeter stp_list_other', stp_list_other);
			stp_list_obj[`${selectedYearFd?.label}`] = stp_list_other
			setStpListOther(stp_list_obj)
		}
		setAllocationLookUpId(null);

	};

	const isInvalidSTP = stpList.some(
		(item) => item.scheme_code === item.stp_scheme_code
	);

	const ASSET_COLUMNS = [
		{
			name: 'Name',
			selector: 'name',
			cell: (row) => row.name ? row.name : '--',
			sortable: false,
			left: true,
			width: "280px",
		},

		{
			name: 'Order',
			selector: (row) => row.order ? row.order : '--',
			sortable: false,
			right: false,
			width: "180px",
		},
		{
			name: 'Color',
			cell: (row) => row.color ? <div style={{ height: "20px", width: "200%", background: row.color }} /> : "-",
			sortable: false,
			right: false,
			width: "120px",
		},
		{
			name: "",
			cell: row => <div className='d-flex'>
				<PrimaryLink name="Edit asset class"
					handleClick={() => {
						setAssetData(row);
						_openAssetModal();
						setUpdate(true);
					}} />

				{/* <PrimaryLink name="Delete"
					className='e-link-delete ps-4'
					toggle="modal"
					target="#confirmationEquity"
					handleClick={() => {
						setAssetData(row);
					}} /> */}
			</div>
		}
	];

	const getGroupedAllocationTotal = (groups = {}) => {
		let total = 0;

		Object.values(groups).forEach((group) => {
			(group || []).forEach((fund) => {
				total += Number(fund.allocation || 0);
			});
		});

		return total;
	};

	const currentEquityAllocation = getGroupedAllocationTotal(fundData[value]?.equity);
	const currentDebtAllocation = getGroupedAllocationTotal(fundData[value]?.debt?.[selectedYear?.value]);
	const currentOtherBasketAllocation = getGroupedAllocationTotal(fdData[selectedYearFd?.label]?.funds_list);
	/* type=null (Other baskets): delete_enabled gates the Delete Basket action
	 * for the currently selected basket. */
	const selectedBasketDeleteEnabled = fdData?.[selectedYearFd?.label]?.delete_enabled === true;

	return (
		<>

			<div className="row pb-5">
				<div className="col-lg-12">
					<div className="card e-dashboard-card e-faq-card  border-0 p-0">
						{/*-------------- baskets ----------*/}
						<div className='row px-4 pt-4 align-items-center justify-content-between'>
							<div className='col-lg-6 col-6 e-funds-tab mt-2 '>
								<FundsTab data={TAB_DATA}
									funds={true}
									index={index}
									setTab={(temp, name, goal) => {
										setIndex(temp);
										setBasket(name);
										setSelectedYear({ label: "1 yr", value: 1 });
										setGoal(goal);
										setType(1);
										setValue("lumpsum")
									}} />
							</div>
							{
								index === 3 ?
									<div className="col-lg-6 col-6">

										<div className='d-flex align-items-center gap-3 justify-content-end'>
											<div className="e-add-new-basket " onClick={_openCreateBasketModal}>
												<h6><span className="pe-2 pb-1"><img src={AddNew} alt="add" /></span>Add new basket</h6>
											</div>

											{/* Delete the currently selected basket. Disabled until a
											  * basket is selected; eligibility is enforced server-side. */}
											<div className="e-add-new-basket e-delete-basket"
												onClick={_openDeleteBasketModal}
												style={(!selectedYearFd?.value || !selectedBasketDeleteEnabled) ? { opacity: 0.4, pointerEvents: "none" } : { cursor: "pointer" }}>
												<h6>Delete basket</h6>
											</div>

											<div className="e-other-basket-select">
												<SelectBox
													options={fdOptions}
													value={selectedYearFd}
													isSearchable={false}
													width="100%"
													selectchange={(temp) => {
														setSelectedYearFd(temp)
													}} />
											</div>
										</div>
									</div>


									:
									null
							}
						</div>



						{/*----------- list of funds added ------------------*/}
						{index !== 4 && <div className='row pt-3 mx-0 mb-3 ps-4'>
							<div className={` col-lg-12 ps-0 pt-2 e-type-sec`}>
								<div className='d-flex'>
									{
										(index === 3 ? TYPE_TAB : TYPE_TAB_ACTIVE).map((item, tabKey) => {
											return (
												<span
													className={type === item.id ? `e-active-tab me-4` : `e-tab me-4`}
													onClick={() => {
														setType(item.id);
														setValue(item.value);
														setSelectedYear({ label: "1 yr", value: 1 })
													}} key={tabKey}
												>
													{item.title}
												</span>
											)
										})
									}
								</div>
							</div>
						</div>
						}
						{
							index < 3 ?
								<>

									{
										type !== 3 ?
											<>
												<div className='row mb-3 ps-4'>
													<div className='col-lg-12 d-flex pt-4 pb-0 e-equity'>
														<h6 className='mb-0'>Equity</h6>
														<p className='ps-3 mb-0'>Allocation
															{
																fundData[value] && Object?.keys(fundData)?.length > 0 && Object?.keys(fundData[value])?.length > 0 && Object?.values(fundData[value]?.equity)?.length > 0 ?
																	<span className='ps-2'>{currentEquityAllocation}%</span>
																	:
																	<span className='ps-2'>0%</span>
															}
														</p>
													</div>
												</div>
												{
													fundLoader ?
														<Loader />
														:
														<>
															{
																fundData[value] && Object.keys(fundData)?.length > 0 && Object?.keys(fundData[value])?.length > 0 && Object?.values(fundData[value]?.equity)?.length > 0 ?
																	<div className="col-lg-12 px-4">
																		<Accordion
																			data={fundData[value].equity}
																			index={index}
																			name={basket}
																			updatedFund={(data) => {
																				_getFunds();
																				setUpdated(data);
																			}}
																			close={() => {
																				_getFunds(false)
																			}}
																			setEditedData={(item) => {
																				setEdiedData(item)
																			}}
																		/>
																	</div>
																	:
																	null
															}
															<div className="row mx-0 px-4">
																<div className="e-add-sec col-lg-12 " onClick={() => {
																	setAddFund(true);
																	setIsDebt(false)
																	setEdiedData({})
																}}>
																	<h6><span className="pe-3"><img src={AddNew} alt="add" /></span>Add New</h6>
																</div>
															</div>
														</>
												}

												<div className='row mb-2 px-4'>
													<div className='col-lg-9 col-9 d-flex e-equity pt-3'>
														<h6 className='mb-0 '>Debt</h6>
														<p className='ps-3 mb-0'>Allocation
															{
																fundData[value] && Object.keys(fundData).length > 0 && Object.keys(fundData[value]).length > 0 && Object.keys(fundData[value].debt).filter((item) => Number(item) === selectedYear.value).length > 0 ?
																	<span className='ps-2'>{currentDebtAllocation}%</span>
																	:
																	<span className='ps-2'>0%</span>
															}
														</p>
													</div>
													<div className='col-lg-3 col-3'>
														<SelectBox
															options={debtOptions}
															value={selectedYear}
															isSearchable={false}
															selectchange={(temp) => setSelectedYear(temp)} />
													</div>
												</div>
												{
													fundLoader ?
														<Loader />
														:
														<>

															{
																fundData[value] && Object.keys(fundData).length > 0 && Object.keys(fundData[value]).length > 0 && Object.keys(fundData[value].debt).filter((item) => Number(item) === selectedYear.value).length > 0 ?
																	<div className="col-lg-12 px-4">

																		<AccordionDebt
																			data={fundData[value].debt[selectedYear?.value]}
																			index={index}
																			name={basket}
																			updatedFund={(data) => {
																				_getFunds();
																				setUpdated(data);
																			}}
																			close={() => {
																				_getFunds(false)
																			}}

																			setEditedData={(item) => {
																				setEdiedData(item)
																			}}
																		/>
																	</div>
																	:
																	null
															}
															<div className="row mx-0 px-4">
																<div className="e-add-sec col-lg-12 " onClick={() => {
																	setAddFund(true);
																	setIsDebt(true)
																	setEdiedData({})
																}}>
																	<h6><span className="pe-3"><img src={AddNew} alt="add" /></span>Add New</h6>
																</div>
															</div>
														</>
												}
											</>
											:
											<>
												<div className='row mb-3 ps-4'>
													{/* <div className='col-lg-12 d-flex pt-4 pb-0 e-equity'>
														<p className='mb-0'>Allocation
															{
																stpList.length > 0 ?
																	<span className='ps-2'>{stpList.reduce((a, b) => a + b.allocation, 0)}%</span>
																	:
																	<span className='ps-2'>0%</span>
															}
														</p>
													</div> */}
													<div className='col-12 pt-4'>
														<div className='e-stp-wrapper'>
															<div className='px-4 pt-4 pb-3'>
																<div className='row'>
																	<div className='col-4'>
																		<h5 className='mb-0'>STP From</h5>
																	</div>
																	<div className='col-2'>
																		<h5 className='mb-0'>Allocation</h5>
																	</div>

																	<div className='col-4'>
																		<h5 className='mb-0'>STP To</h5>
																	</div>
																	<div className='col-2 position-relative'>
																		<h5 className='mb-0'>Allocation
																			<img src={require("../../assets/images/dataFormating/Icon.png").default}
																				alt="Icon"
																				className='ms-2'
																				style={{ cursor: "pointer" }}
																				onMouseEnter={() => setTooltip(true)}
																				onMouseLeave={() => setTooltip(false)} />
																		</h5>
																		{
																			tooltip ?
																				<IconStyleToolTip
																					hover={() => { }}
																					className="e-stp-tooltip"
																					content={`STP allocation cannot be changed manually. It automatically adjusts only when the allocation of the linked lumpsum fund is modified.`} />

																				:
																				null
																		}
																	</div>
																</div>
															</div>
															{
																stpList.map((item, index) => {
																	return (
																		<div className='px-4 e-stp-body-wrapper py-3'>
																			<div className='row align-items-center'>
																				<div className='col-4'>
																					<div className={`e-stp-fund ${!item.stp_fund_name ? "cursor-pointer" : ""}`} onClick={() => {
																						if (!item.stp_fund_name) {
																							setAllocationLookUpId(item.id);
																							_openAddSTPFundModal();
																							setSelectedSTPIndex(index);
																							setStpIndex(item.stp_fund_id)
																						}
																					}}
																						style={item.stp_fund_name ? { paddingRight: "28px" } : { paddingLeft: "40px" }}>
																						{!item.name && <img src={require("../../assets/images/cta/search.svg").default}
																							alt="search"
																							width={16}
																							className='e-stp-search' />}
																						<p className='mb-0'>{item.stp_fund_name ? item.stp_fund_name : "Search funds"}{item.stp_fund_name ? <span>({item.stp_scheme_code})</span> : null}</p>
																						{item.stp_fund_name && <img src={require("../../assets/images/cta/close-black.png").default}
																							alt="close"
																							width={12}
																							className='e-stp-search-clear'
																							onClick={() => {
																								_openDeleteConfirm(index);
																							}} />}
																					</div>

																				</div>
																				<div className='col-2'>
																					<p className='mb-0'>{item.allocation}%</p>
																				</div>
																				<div className='col-4'>
																					<p className='mb-0'>{item.name}<span>({item.scheme_code})</span></p>
																				</div>

																				<div className='col-2'>
																					<span className='mb-0' style={{ opacity: "0.5" }}>{item.allocation}%</span>
																				</div>
																			</div>
																		</div>
																	)
																})
															}
															<div className='row px-4 mt-3 justify-content-end'>
																<div className='col-lg-2 offset-lg-10 pb-3 text-end'>
																	<PrimaryBtn
																		name="Update"
																		className={
																			stpList.every(item => item.stp_scheme_code !== null) ? syncLoader ? "e-btn-loader " : "" : "e-disabled"}
																		handleClick={() => {
																			if (isInvalidSTP) {
																				setError("STP 'From' and 'To' funds cannot be the same");
																				return;
																			}
																			_upsertStp();
																		}} />
																</div>
															</div>
														</div>
													</div>
												</div>
											</>
									}

								</>
								:
								index === 3 ?
									fundLoader ?
										<Loader />
										:
										<>

											{
												type !== 3 ?
													<>
														<div className='col-lg-12 d-flex e-equity pt-3 px-4'>
															<p className='ps-0'>Allocation
																{
																	fdData && Object.keys(fdData).length > 0 && fdData[selectedYearFd.label]?.funds_list && Object.keys(fdData[selectedYearFd.label].funds_list).length > 0 ?
																		<span className='ps-2'>
																			{
																				currentOtherBasketAllocation
																			}%
																		</span>
																		:
																		<span className='ps-2'>0%</span>
																}
															</p>
														</div>

														{

															fdData && Object.keys(fdData).length > 0 && fdData[selectedYearFd.label]?.funds_list && Object.keys(fdData[selectedYearFd.label].funds_list).length > 0 && Object.keys(fdData).filter((item) => item === selectedYearFd.label).length > 0 ?
																<div className="col-lg-12 px-4">
																	<Accordion
																		data={fdData[selectedYearFd.label].funds_list}
																		index={index}
																		name={basket}
																		updatedFund={(data) => {
																			_getFunds();
																			setUpdated(data);
																		}}
																		setEditedData={(item) => {
																			setEdiedData(item);
																		}}
																		close={() => {
																			_getFunds(false)
																		}}
																	/>
																	{/* <Accordion
														data={fundData["value"].equity}
														index={index}
														name={basket}
														updatedFund={(data) => {
															_getFunds();
															setUpdated(data);
														}}
													/> */}
																</div>
																:
																null
														}
														<div className="row mx-0 px-4">
															<div className="e-add-sec col-lg-12 " onClick={() => { setAddFund(true); setEdiedData({}) }}>
																<h6><span className="pe-3"><img src={AddNew} alt="add" /></span>Add New</h6>
															</div>
														</div>
													</>
													:
													<>
														<div className='row mb-3 ps-4'>
															{/* <div className='col-lg-12 d-flex pt-4 pb-0 e-equity'>
																<p className='mb-0'>Allocation
																	{
																		stpListOther[selectedYearFd?.label].length > 0 ?
																			<span className='ps-2'>{stpListOther[selectedYearFd?.label].reduce((a, b) => a + b.allocation, 0)}%</span>
																			:
																			<span className='ps-2'>0%</span>
																	}
																</p>
															</div> */}
															<div className='col-12 pt-4'>
																<div className='e-stp-wrapper'>
																	<div className='px-4 pt-4 pb-3'>
																		<div className='row'>
																			<div className='col-4'>
																				<h5 className='mb-0'>STP From</h5>
																			</div>
																			<div className='col-2'>
																				<h5 className='mb-0'>Allocation</h5>
																			</div>
																			<div className='col-4'>
																				<h5 className='mb-0'>STP to</h5>
																			</div>
																			<div className='col-2 position-relative'>
																				<h5 className='mb-0'>Allocation
																					<img src={require("../../assets/images/dataFormating/Icon.png").default}
																						alt="Icon"
																						className='ms-2'
																						style={{ cursor: "pointer" }}
																						onMouseEnter={() => setTooltip(true)}
																						onMouseLeave={() => setTooltip(false)} />
																				</h5>
																				{
																					tooltip ?
																						<IconStyleToolTip
																							hover={() => { }}
																							className="e-stp-tooltip"
																							content={`STP allocation cannot be changed manually. It automatically adjusts only when the allocation of the linked lumpsum fund is modified.`} />

																						:
																						null
																				}
																			</div>
																		</div>
																	</div>
																	{
																		stpData.length === 0 ? (
																			<div className="text-center py-5">
																				<h6 className="mb-2">No STP funds added</h6>
																				<p className="text-muted mb-3">
																					Add funds to configure STP transfers
																				</p>

																				<PrimaryBtn
																					name="+ Add STP Fund"
																					handleClick={() => {
																						setAddFund(true);
																						setIsDebt(false)
																						setEdiedData({})
																					}}
																				// handleClick={() => _openAddSTPFundModal()}
																				/>
																			</div>
																		) :

																			(stpData.map((item, index) => {
																				return (
																					<div className='px-4 e-stp-body-wrapper py-3'>
																						<div className='row align-items-center'>
																							<div className='col-4'>
																								<div className={`e-stp-fund ${!item.stp_fund_name ? "cursor-pointer" : ""}`} onClick={() => {
																									if (!item.stp_fund_name) {
																										setAllocationLookUpId(item.id);
																										_openAddSTPFundModal();
																										setOtherSTPIndex(index);
																										setStpIndex(item.stp_fund_id)
																									}
																								}}
																									style={item.stp_fund_name ? { paddingRight: "28px" } : { paddingLeft: "40px" }}>
																									{!item.stp_fund_name && <img src={require("../../assets/images/cta/search.svg").default}
																										alt="search"
																										width={16}
																										className='e-stp-search' />}
																									<p className='mb-0'>{item.stp_fund_name ? item.stp_fund_name : "Search funds"}{item.stp_scheme_code ? <span>({item.stp_scheme_code})</span> : null}</p>
																									{item.stp_fund_name && <img src={require("../../assets/images/cta/close-black.png").default}
																										alt="close"
																										width={12}
																										className='e-stp-search-clear'
																										onClick={() => {
																											_openDeleteConfirm(index);
																										}} />}
																								</div>

																							</div>
																							<div className='col-2'>
																								<p className='mb-0'>{item.allocation}%</p>
																							</div>
																							<div className='col-4'>
																								<p className='mb-0'>{item.name}<span>({item.scheme_code})</span></p>
																							</div>

																							<div className='col-2'>
																								<span className='mb-0' style={{ opacity: "0.5" }}>{item.allocation}%</span>
																							</div>
																						</div>
																					</div>
																				)
																			})
																			)
																	}
																	<div className='row px-4 mt-3 justify-content-end'>
																		<div className='col-lg-2 offset-lg-10 pb-3 text-end'>
																			<PrimaryBtn
																				name="Update"
																				className={stpData.length > 0 && stpData.every(item => item.stp_scheme_code !== null) ? syncLoader ? "e-btn-loader " : "" : "e-disabled"}
																				handleClick={() => {
																					_upsertStp()
																				}} />
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</>
											}
										</>
									:
									assetListLoader ?
										<Loader />
										:

										<div className="row mx-0 mt-4">
											<div className='col-lg-3 offset-9'>
												<div className="e-add-sec d-flex justify-content-center " onClick={() => _openAssetModal()}>
													<h6 className='px-0 d-flex justify-content-center'><span className="pe-3"><img src={AddNew} alt="add" /></span>Add new asset class</h6>
												</div>
											</div>
											<div className='col-12 px-0'>
												{
													assetList.length > 0 ?
														<Datatable
															columns={ASSET_COLUMNS}
															data={assetList}
														/>
														:
														<EmptyNote note="No data" />
												}
											</div>
										</div>

						}

						{/* sync data buttton */}
						{
							index !== 4 && type !== 3 ?
								<div className='row mt-auto mb-4 mx-3'>
									<div className='col-lg-2 offset-lg-10 text-end'>
										<PrimaryBtn
											name="Sync data"
											className={syncLoader ? "e-btn-loader " : ""}
											handleClick={() => {
												_syncData()
											}} />
										{/* <PrimaryBtn
											name="Sync data"
											handleClick={() => {

												//  Only check FD allocation
												const totalFd = Number(fdAllocation || 0);

												if (Math.round(totalFd) !== 100) {
													setError(`Total allocation must be exactly 100% (Current: ${totalFd}%)`);
													return;
												}

												_syncData();
											}}
										/> */}
									</div>
								</div>
								:
								null
						}
					</div>
				</div>
			</div>
			{/* success toast */}
			{
				success !== null ?
					<Toast data={success} type="success" id="2" />
					:
					null
			}

			{
				error !== null ?
					<Toast data={error} type="error" id="2" />
					:
					null
			}

			<AddAssetClass
				data={assetData}
				update={update}
				addedClass={() => _getAssetClass()}
				closeAssetModal={() => {
					setAssetData({});
					setUpdate(false)
				}} />

			<Confirmation
				deleteClass={true}
				content="Are you sure , you want to delete this Asset?" />

			<DeleteFund
				closeModal={() => setSelectedFund(null)}
				deleteFund={_deleteFund} />

			<CreateBasketModal
				basketCreatedStatus={basketCreatedStatus}
				// closeModal={() => s}
				handleCreate={(payload) => {
					_createNewBasket(payload)
				}}
			/>

			{/*----------- Delete basket confirmation ------------------*/}
			<div className="modal fade" id="delete-basket-confirm" tabIndex="-1" aria-labelledby="delete-basket-title" aria-hidden="true" data-bs-backdrop="static">
				<div className="modal-dialog modal-dialog-centered">
					<div className="modal-content border-radius-12">
						<div className="modal-header border-0 pb-0">
							<h6 id="delete-basket-title" className="mb-0">Delete basket</h6>
							<button type="button"
								className="btn-close"
								id="close-delete-basket"
								data-bs-dismiss="modal"
								aria-label="Close"
								disabled={deleteBasketLoader} />
						</div>
						<div className="container px-3 pt-2 pb-4">
							<div className="row">
								<div className="col-12">
									<p className="mb-0">
										Are you sure you want to delete
										{selectedYearFd?.label ? ` "${selectedYearFd.label}"` : " this basket"}?
										A basket can only be deleted if it has no investments and no pending orders.
									</p>
								</div>
							</div>
							<div className="row pt-4">
								<div className="col-12 d-flex justify-content-end gap-3">
									<SecondaryBtn name="Cancel" cancel="modal" />
									<PrimaryBtn
										name="Delete basket"
										className={deleteBasketLoader ? "e-btn-loader" : ""}
										handleClick={() => {
											if (deleteBasketLoader) return;
											_deleteBasket();
										}} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{showSuccessModal && (
				<SuccessConfirmationModal
					type={2}
					closeModal={() => setShowSuccessModal(false)}
					message="Basket created successfully"
				/>
			)}

			{/*----------- Modal to add fund ------------------*/}

			<FundClass
				debt={isDebt}
				index={index}
				name={basket}
				goal={goal}
				type={type}
				editedData={editedData}
				year={selectedYearFd}
				options={debtOptions}
				close={() => {
					setIsDebt(false);
					setAddFund(false);
					setEdiedData({});
				}}
				addedFund={(data) => { _getFunds(); setUpdated(data) }}
			/>

			{
				openFundAddModal ?
					<AddFund type={type}
						allocationId={allocationLookUpId}
						updateList={_updateStpList}
						closeModal={() => setOpenFundAddModal(false)} />
					:
					null
			}




		</>
	)
}

export default Index;
